import React, { useState } from "react";
import Image from "next/image";
import useMilesOneDeepLink from "@/hooks/useMilesOneDeepLink";

const MilesAppStripDownload = () => {
  const [isVisible] = useState(true);
  const { tryOpenApp } = useMilesOneDeepLink();

  if (!isVisible) return null;

  return (
    <div className="relative w-full h-[42px] bg-[#061A2F] flex items-center px-4 py-6">
      <div className="w-full flex justify-start cursor-pointer">
        <div className="flex items-center">
          <div className="w-[26px] h-[26px] rounded-[4px] flex items-center justify-center overflow-hidden">
            <Image
              src="/icon-miles.png"
              alt="Miles Icon"
              width={22}
              height={22}
              style={{ objectFit: "contain" }}
            />
          </div>
          <p
            className="text-white text-[12px] font-medium leading-[16px] tracking-[-0.02em] text-center"
            style={{
              fontFamily: "Work Sans",
              width: "210px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Download the Miles One app now!
          </p>
        </div>
      </div>
      <div className="">
        <button
          className=" bg-[#fff] text-[#1772EA] rounded-[20px_20px_20px_0] flex p-2 items-center gap-2 w-[56px] h-[26px] justify-center"
          onClick={() => {
            tryOpenApp();
          }}
        >
          <span className="font-bold text-[10px]">Open</span>
        </button>
      </div>
    </div>
  );
};

export default MilesAppStripDownload;
